import { IQueryParams } from '../../../../models';
import {
  clearEventListDetails,
  fetchEventListFail,
  fetchEventListStarted,
  fetchEventListSuccess
} from '../../../reducer/events/EventListReducer';
import { fetchEventList } from '../../actionType/events/EventListActionTypes';
import {
  ClearAllEvent,
  FetchAllEventFailure,
  FetchAllEventFailurePayload,
  FetchAllEventRequest,
  FetchAllEventStarted,
  FetchAllEventSuccess,
  FetchAllEventSuccessPayload
} from '../../types/events/GetAllEventListTypes';

export const fetchEventListRequest = (pageNo: number, item: number, queryParams?: IQueryParams, sort?: string): FetchAllEventRequest => ({
  type: fetchEventList.FETCH__EVENT_LIST_REQUEST,
  pageNo,
  item,
  queryParams,
  sort
});

/**
 * Fetch All event  started saga action
 * @returns service event started action
 */
export const getAllEventStarted = (): FetchAllEventStarted => ({
  type: fetchEventListStarted.type
});

/**
 * Fetch all event success saga action
 * @param payload : all Event data
 * @returns success action
 */
export const getAllEventSuccess = (
  payload: FetchAllEventSuccessPayload
): FetchAllEventSuccess => ({
  type: fetchEventListSuccess.type,
  payload
});

/**
 * Fetch All Event Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const fetchAllEventFailure = (
  payload: FetchAllEventFailurePayload
): FetchAllEventFailure => ({
  type: fetchEventListFail.type,
  payload
});

/**
 * Clear All Events saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearAllEvent = (): ClearAllEvent => ({
  type: clearEventListDetails.type
});
